import { useGraphQLQuery, useMatchMedia } from '@betterment/js-runtime';
import { Box, Card, Heading, Separator, Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { CardLoader, ErrorBoundary, SambaAutoLink } from '@betterment/shared-components';

import OnboardingImage from '../../../../images/premium_onboarding_coach_phone_window.svg';
import { urlBuilder } from '../../../../Shared/urlBuilder';
import { ForecasterPremiumOnboardingCardDocument } from '../../graphql/forecasterPremiumOnboardingCard.generated';

const PremiumOnboardingCardView = () => {
  const { data } = useGraphQLQuery(ForecasterPremiumOnboardingCardDocument, { throwOnError: true });
  const isAtLeastExtraLarge = useMatchMedia('atLeastExtraLarge');

  if (!data) return <CardLoader />;
  if (!data.premiumOnboardingOption || data.premiumOnboardingOption.hasScheduledMeeting) return null;

  const { fee, feeDisclosure } = data.premiumOnboardingOption;
  const onboardingUrl = urlBuilder.appAdviceInitiationFlow.absolute();

  return (
    <Card>
      <Card.Content css={{ display: 'flex', flexDirection: 'column', padding: 'space.300', gap: 'space.300' }}>
        <Box css={{ display: 'flex', gap: 'space.300' }}>
          <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.200' }}>
            <Heading variant="title200">
              Upgrade to Premium for on-demand support from a Certified Financial Planner&trade;
            </Heading>
            <Text variant="text100">
              Get one-on-one guidance from a CFP<sup>&reg;</sup> tailored to your goals for a {fee}% add-on fee.
            </Text>
            <SambaAutoLink
              to={onboardingUrl}
              css={{ alignSelf: 'flex-start' }}
              variant="solidSecondary"
              spacing="compact"
            >
              Schedule a call
            </SambaAutoLink>
          </Box>
          {isAtLeastExtraLarge && (
            <img src={OnboardingImage} aria-hidden="true" alt="" className={css({ objectFit: 'contain' })} />
          )}
        </Box>
        <Separator />
        <Text variant="text25" css={{ color: 'text.weak' }} dangerouslySetInnerHTML={{ __html: feeDisclosure }} />
      </Card.Content>
    </Card>
  );
};

export const PremiumOnboardingCard = () => {
  return (
    <ErrorBoundary fallbackType="none">
      <PremiumOnboardingCardView />
    </ErrorBoundary>
  );
};
